import { useAppDispatch } from 'flow/hooks/useRedux';
import { CallRecordKey, ExtendedTranscriptionKey } from 'flow/types/EntityKeys';
import { deleteTranscription } from 'flow/actions/RecordedCallsActions';
import BaseModal from 'flow/components/ui-components/BaseModal';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    extendedTranscriptionKey?: ExtendedTranscriptionKey;
    callRecordKey?: CallRecordKey;
    isPersonal?: boolean;
}

const DialogDeleteExtendedTranscription = ({
    extendedTranscriptionKey,
    callRecordKey,
    isPersonal,
}: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const onConfirm = () => {
        if (!extendedTranscriptionKey || !callRecordKey) return;
        dispatch(
            deleteTranscription(
                extendedTranscriptionKey,
                callRecordKey,
                !!isPersonal,
            ),
        );
    };

    return (
        <BaseModal
            open={true}
            header={i18next.t('call.transcription.delete.confirm.title')}
            onSubmit={onConfirm}
            confirmButtonText={i18next.t('Delete.Button.Text')}
            confirmButtonColor="danger"
        >
            {i18next.t('call.transcription.delete.confirm.description')}
        </BaseModal>
    );
};

export default DialogDeleteExtendedTranscription;
